import React, { useEffect } from "react";
import videojs from "video.js";
import Player from "video.js/dist/types/player";

import "video.js/dist/video-js.css";

// This Options construction allow options to show what are atleast supported and commonly used.
type VideoJSOptionsBase = {
        play?: boolean | "play" | "muted" | "any";
        sources?: {
            src: string; // URL to stream
            type: string; // Mime type. Eg: "application/x-mpegURL"
        }[];
        autoplay?: boolean; // Start play automatically
        controls?: boolean; // Show native controls (Stop/play/pause etc)
        liveui?: boolean; // Live ui prepare player for live stream feed
        html5?: {
            hls?: {
                enableLowInitialPlaylist?: boolean;
                overrideNative?: boolean; // ensures playback in Chrome/Firefox
            };
        };
    };

// Know options + any record to allow more options than defined
type VideoJSOptions = VideoJSOptionsBase & Record<string, any>

// VideoJSPlayer props
interface VideoJSPlayerProps {
    onReady?: (player: Player) => void;
    options?: VideoJSOptions;
};

// Video JS player wrapper over video.js library.
// Do not add any EasyOpp app specific logis in to this control directly to keep reusabilityf
export const VideoJSPlayer = (props: VideoJSPlayerProps) => {
    const videoRef = React.useRef<HTMLDivElement>(null);
    const playerRef = React.useRef<Player>(null);
    const { options, onReady } = props;

    useEffect(() => {

        // Make sure Video.js player is only initialized once
        if (!playerRef.current) {
            // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
            const videoElement = document.createElement("video-js");

            videoElement.classList.add("vjs-big-play-centered");
            videoRef.current.appendChild(videoElement);

            const player = playerRef.current = videojs(videoElement, options, () => {
                videojs.log("player is ready");
                onReady && onReady(player);
            });

        } else {
            // Existing player. Update necessary options, sources etc.
            const player = playerRef.current;

            player.autoplay(options.play);
            player.src(options.sources);
        }

        return () => {
            if (playerRef.current && !playerRef.current.isDisposed()) {
                playerRef.current.dispose();
                playerRef.current = null;
            }
        };
    }, [options, videoRef, playerRef]);

    return (
        <div data-vjs-player>
            <div ref={videoRef} />
        </div>
    );
};

export default VideoJSPlayer;